import React, { useEffect } from 'react'
import { X, Monitor, Tv, AlertTriangle } from 'lucide-react'

const DeviceLimitModal = ({ isOpen, onClose, deviceLimit, currentCount }) => {
  // Prevent background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      return () => { document.body.style.overflow = originalOverflow }
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div 
      className="fixed bg-black bg-opacity-50 flex items-center justify-center z-50" 
      style={{ 
        top: 0, 
        left: 0, 
        right: 0, 
        bottom: 0, 
        margin: 0, 
        padding: 0,
        width: '100vw',
        height: '100vh'
      }}
    >
      <div className="bg-white rounded-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="p-2 bg-yellow-100 rounded-lg mr-3">
              <AlertTriangle className="w-6 h-6 text-yellow-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Device Limit Reached</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <h3 className="font-medium text-gray-900 mb-3">Screen Assignment Limit</h3>
            <p className="text-gray-600 mb-4">
              You have reached your device limit for screens ({currentCount}/{deviceLimit} devices).
            </p>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
              <div className="flex items-start space-x-3">
                <Tv className="w-5 h-5 text-blue-600 mt-0.5" />
                <div>
                  <h4 className="font-medium text-blue-900 mb-1">Live Channels Are Unlimited!</h4>
                  <p className="text-sm text-blue-700">
                    You can assign live channels to any number of devices without limits. 
                    Consider using channels instead of screens for your content.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <Monitor className="w-5 h-5 text-gray-600 mt-0.5" />
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Upgrade Your Plan</h4>
                  <p className="text-sm text-gray-700">
                    To assign more screens to devices, consider upgrading your subscription 
                    to get a higher device limit.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Close
          </button>
          <button
            onClick={() => {
              onClose()
              // Navigate to channels page
              window.location.href = '/user-channels'
            }}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            Go to Channels
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeviceLimitModal 